var Backbone = bookedby.deps != null ? bookedby.deps.Backbone : global.Backbone;
var $ = bookedby.deps != null ? bookedby.deps.$ : global.$;

var SelectorView = Backbone.Epoxy.View.extend({
  initialize: function(options) {
    options = options || {};
    if (options.model == null) {
      throw new Error('ComponentView requires a model');
    }
    if (options.boundProperty == null) {
      throw new Error('ComponentView requires boundProperty to be set');
    }
    this.boundProperty = options.boundProperty;
    this.referenceContainer = options.referenceContainer || null;
    this.ignoreNextFocusOut = false;
    this.ignoreNextFocusIn = false;
    this.isIe = !!window.MSInputMethodContext && !!document.documentMode;
  },

  hideAllLists: function(e) {
    var self = this;

    if (this.isIe && e && e.type === 'focusout') {
      return;
    }

    setTimeout(function() {
      if (!self.ignoreNextFocusOut) {
        self.$('.select-list, .select-service-list-sub').addClass('hidden');
        if ($('.employee-selector')) $('.employee-selector').attr('aria-expanded', 'false');
      } else {
        self.$(e.target).focus();
      }
      self.ignoreNextFocusOut = false;

      }, 200);
  },

  highlightItem: function(ol, item) {
    this.$('.select-list li:visible, .select-sub-list li:visible').removeClass("active");
    this.$("#" + ol + " li:visible").eq(item).addClass("active");
  },
  navigateList: function(ol, direction) {
    // Determine if the selected list is the categories or services list
    ol = (this.$('#mainSelectService li.active').length == 1) ? 'mainSelectService' : ol;

    if (this.$("#" + ol + " li.active").length == 0) {
      selectedItem = -1;
    }

    if (direction == 'up' && selectedItem != -1) {
      if(selectedItem != 0) {
        selectedItem --;
      }
    }

    else if (direction == 'down') {
      if(selectedItem != this.$("#" + ol + " li:visible").size() - 1) {
        selectedItem ++;
      }
    }
    this.highlightItem(ol, selectedItem);
  },
  selectItem: function(options) {
    // update data attributes
    this.$input.attr('data-id', options.id);
    // Change value
    this.$input.val(options.name);
    this.valueChanged();

    this.hideAllLists();
  },
  selectItemWithEnterKey: function(key, keys) {
    if (key == keys.enter) {
      var el = this.$('.select-list .active').first();
      var o = {
        id: el.attr('data-id'),
        name: el.find('span').text()
      }
      this.selectItem(o);
    }
  },

  showListWithKeys: function(key, keys) {
    var listIsHidden = this.$('.select-list:hidden').length > 0;

    if (listIsHidden && (key == keys.down)) {
      this.showList();
    }
  },

  hideListWithKeys: function(key, keys) {
    if (key == keys.esc) {
      this.hideList();
    }
  },

  focusOnInput: function(e) {
    e.preventDefault();
    this.$(e.target).focus();
  },

  focusOnInputWithImg: function(e) {
    this.ignoreNextFocusOut = true;

    e.preventDefault();
    this.$input.focus();

    var self = this;
    setTimeout(function() {
      self.ignoreNextFocusOut = false;
    }, 300);
  },

  focusOnInputWithAddon: function (e) {
    this.ignoreNextFocusOut = true;
    this.focusOnInput(e);

    var self = this;
    setTimeout(function() {
      self.ignoreNextFocusOut = false;
    }, 300);
  },

  recomputePosition: function($elem, withTimeOut) {
    if ($elem.length > 0) {

      var self = this;

      var recFun = function() {
        $elem.removeClass('hidden');
        if ($('.employee-selector')) $('.employee-selector').attr('aria-expanded', 'true');
        if ($elem.prop("tagName") == 'DIV') {
          var $containerElem = $elem.find('ol');
        } else {
          $containerElem = $elem;
        }

        /**
         * Remove element top from previous iterations
         */
        $elem.css("cssText", "top: '' !important;");

        var winHeight = document.body.clientHeight;
        var elemHeight = $containerElem.height();
        var elemTop = $containerElem.offset().top;
        var elemParentTop = $containerElem.position().top;
        var scrollTop = $(window).scrollTop();
        var winTopDistance = elemTop - scrollTop;

        if (self.referenceContainer) {
          var referenceContainerHeight = $(self.referenceContainer).height();
          var referenceContainerPos = $(self.referenceContainer).offset().top;
          var referenceContainerAbsPos = $(self.referenceContainer).position().top;

          if (elemTop + elemHeight > referenceContainerHeight + referenceContainerPos) {
            var overallTop = (referenceContainerHeight + referenceContainerPos) - (elemHeight + scrollTop);
            if (overallTop < 0) {
              overallTop = elemParentTop + 10;
            } else {
              overallTop -= 20;
            }
            var relativeTop = -(elemTop - overallTop);

            if ((referenceContainerAbsPos - (elemTop - overallTop)) < 0)
              relativeTop = (-1 * referenceContainerAbsPos) + 50;

            if (((elemTop - referenceContainerPos) - 30) < Math.abs(relativeTop)) {
              relativeTop = -((elemTop - referenceContainerPos) - 30);
            }

            $elem.css("cssText", "top: " + relativeTop + "px !important;");
          }
        } else {

          /**
           * if element goes off the element bottom, push element up
           */
          if (winTopDistance + elemHeight > winHeight) {
            var globalTop = winHeight - elemHeight + scrollTop;
            if (globalTop < 0) {
              globalTop = elemParentTop + 10;
            } else {
              globalTop -= 20;
            }
            var newTop = -(elemTop - globalTop);
            $elem.css("cssText", "top: " + newTop + "px !important;");
          }
        }

        self.ignoreNextFocusIn = false;
      };

      if (withTimeOut) {
        setTimeout(recFun, 200);
      } else {
        recFun();
      }

    }
  },

  showList: function(e) {
    if (this.ignoreNextFocusIn || (e && e.type == 'focusout')) {
      return;
    }

    var self = this;
    this.ignoreNextFocusIn = true;

    /**
     * reset the option to avoid dead ends (bugfix)
     */
    setTimeout(function() {
      self.ignoreNextFocusIn = false;
    }, 500);

    var $elem = self.$('.select-list');
    this.recomputePosition($elem, true);

    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
  },

  hideList: function() {
    this.$('.select-list').addClass('hidden');
    if ($('.employee-selector')) $('.employee-selector').attr('aria-expanded', 'false');
  },

  deleteSelectedItem: function(key, keys) {
    if (key == keys.backspace || key == keys.del) {
      // Clear input field
      this.$input.val('');
      // Set data attributes to blank
      this.$input.attr('data-id', '');
    }
  },
  keyActions: function(e) {
    var keys = {
      backspace: 8,
      tab: 9,
      enter: 13,
      space: 32,
      esc: 27,
      left: 37,
      up: 38,
      right: 39,
      down: 40,
      del: 46
    };

    var key = e.keyCode;

    if (key == keys.tab) {
      return;
    }

    e.preventDefault();

    // Backspace & Delete
    this.deleteSelectedItem(key, keys);

    // Arrow keys
    this.navigateListWithArrowKeys(key, keys);

    // Enter key selects item
    this.selectItemWithEnterKey(key, keys);

    // Tab or down arrow shows the list if not shown
    this.showListWithKeys(key, keys);
  }
});

module.exports = SelectorView;
